export const ItemListContainer = "w-full overflow-hidden surface-500 border-round";

export const TreeDragNodeHeight = 2;

export const TreeDragNodeImageHeight = TreeDragNodeHeight - 0.2;

export const TreeDragNodeImageHeightStyle = "max-width: " + TreeDragNodeImageHeight + "rem!important;"

export const TreeDragulaNode = 'flex flex-1 flex-column';

export const TreeDragNode = 'flex flex-1 flex-column drag-node';

export const TreeDragNodeContent = "flex flex-1 flex-row column-gap-1 align-items-center medsurf-tree cursor-pointer h-" + TreeDragNodeHeight + "rem drag-node-content";

export const TreeDragNodeContentContainer = 'flex flex-1 flex-column';

export const TreeDragNodeSkeletonHeight = TreeDragNodeHeight + 'rem';

export const TreeDragNodeContentHandleContainer = 'flex justify-content-start w-1rem';

export const TreeDragNodeHiddenElement = 'tree_hidden_element';

export const TreeDragNodeHandleElement = TreeDragNodeHiddenElement + ' handle cursor-move flex-shrink-0';

export const TreeDragNodeContentNoDataContainer = (depth: number) => 'flex justify-content-center depth_indent-' + depth

export const TreeDragNodeContentDropDownContainer = (depth: number) => 'flex justify-content-center w-2rem depth_indent-' + depth

export const TreeDragNodeContentTitleContainer = 'flex flex-1 py-2 px-0 w-0'

export const TreeDragNodeContentAttributesContainer = 'flex justify-content-end w-2rem'

export const TreeDragNodeContentImageContainer = 'flex justify-content-center w-2rem'

export const TreeDragNodeContentOptionContainer = 'flex flex-shrink-0 flex-row flex-nowrap column-gap-2 justify-content-end mr-1 ml-1'

export const TreeDragNodeContentChipContainer = 'flex'

export const TreeDragNodeContentFixedTagContainer = 'align-item-right min-w-tag';

export const TreeDragNodeContentFixedLayerEmptyContainer = 'align-item-right min-w-5rem';

export const TreeDragNodeContentChipContainer2 = 'flex flex-row column-gap-2 white-space-nowrap'

export const TreeDragNodeContentText = 'white-space-nowrap overflow-hidden text-overflow-ellipsis'

export const TreeDragNodeNoDataText = TreeDragNodeContentText + ' p-2'